import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { ButtonAdapter } from '../ButtonAdapter';
import { FormStatus } from '../../../../../types/form-state';
import { ButtonAdapterDataHooks } from '../dataHooks';
import { CartFlow } from '../../../../../types/types';
import { getContent } from '../../../../../utils/content/content';
import settingsParams from '../../../settingsParams';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { SlotServices, SlotService } from '../../../../../utils/state/types';
import { mapToArray } from '../../../../../utils';
import {
  hasPurchasablePlanSelected,
  isPlanAndBookEligible,
} from '../../../../../utils/payment';

export interface BookButtonButtonProps {
  slotServices: SlotServices;
  status: FormStatus;
  cartFlow?: CartFlow;
  primary?: boolean;
  disabled?: boolean;
}

export const BookButton: React.FC<BookButtonButtonProps> = ({
  slotServices,
  status,
  cartFlow,
  primary,
  disabled,
}) => {
  const { experiments } = useExperiments();
  const settings = useSettings();
  let bookButtonLabel = getContent({
    settings,
    settingsParam: settingsParams.bookNowButtonText,
    experiments,
  });

  const isPurchasablePlanSelected = hasPurchasablePlanSelected({
    slotServices,
    experiments,
  });

  if (isPlanAndBookEligible({ slotServices, experiments })) {
    bookButtonLabel = getContent({
      settings,
      settingsParam: settingsParams.buyPlanAndBookButtonText,
      experiments,
    });
  } else if (isPurchasablePlanSelected) {
    // A purchasable plan is selected but Plan & Book is not eligible — fall back
    // to the legacy "Buy a plan" CTA (submitting redirects to the Pricing Plans page).
    bookButtonLabel = getContent({
      settings,
      settingsParam: settingsParams.chooseAPlanText,
      experiments,
    });
  }

  const pendingApprovalService = mapToArray<SlotService>(slotServices).find(
    (service) => service.service.isPendingApprovalFlow,
  );

  if (pendingApprovalService) {
    bookButtonLabel = bookButtonLabel =
      settings.get(settingsParams.requestBookingButtonText) ||
      settings.getDefaultValue?.(settingsParams.requestBookingButtonText);
  }

  return (
    <ButtonAdapter
      label={bookButtonLabel}
      dataHook={ButtonAdapterDataHooks.BOOK_NOW_CTA}
      status={status}
      cartFlow={cartFlow}
      primary={primary}
      disabled={disabled}
    />
  );
};
